import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBuyPackageData } from './types';
import { initialState } from './constants';
import { EBuyPackageStatus } from '../../types/packages';

const buyPackageModalSlice = createSlice({
  name: 'buyPackageModal',
  reducers: {
    setBuyPackageModalData: (state, action: PayloadAction<IBuyPackageData>) => {
      return {
        ...state,
        isVisible: true,
        data: action.payload,
      };
    },
    setBuyPackageModalAutoProlong: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        data: {
          ...state.data,
          autoProlong: action.payload,
        },
      };
    },
    setBuyPackageModalStatus: (state, action: PayloadAction<EBuyPackageStatus>) => {
      return {
        ...state,
        status: action.payload,
      };
    },
    setBuyPackageModalLoading: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isLoading: action.payload,
      };
    },
    setBuyPackageModalError: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        status: EBuyPackageStatus.Error,
        message: action.payload,
      };
    },
    closeBuyPackageModal: () => {
      return initialState;
    },
  },
  initialState,
});

export const buyPackageModalReducer = buyPackageModalSlice.reducer;
export const {
  setBuyPackageModalData,
  setBuyPackageModalAutoProlong,
  setBuyPackageModalStatus,
  setBuyPackageModalLoading,
  setBuyPackageModalError,
  closeBuyPackageModal,
} = buyPackageModalSlice.actions;
